document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelector('#calendar');
  if (elements !== null) {
    const str = elements.querySelector('.marker-dates').innerText;
    const id = elements.querySelector('.initial-date').innerText;
    const json = JSON.parse(str);
    const initial = JSON.parse(id);
    const calendarEl = document.getElementById('calendar');
    const calendar = new FullCalendar.Calendar(calendarEl, {
      initialView: 'dayGridMonth',
      initialDate: initial,
      timeZone: 'UTC',
      locale: 'fr',
      events: json,
      backgroundColor: '#FF5800',
    });
    calendar.render();
  }
});
